module.exports = __webpack_public_path__ + "static/prnt-2e8e1c44940afc4268bde6e593e3c6b7.svg";